const confirmacao_turmas_mediacao_tecnologica = {
  path: "/confirmacao-turmas-mediacao-tecnologica",
  redirect: "/confirmacao-turmas-mediacao-tecnologica",
  meta: {
    breadCrumb: "Planejamento Matricula - Tabelas de Apoio ao Planejamento",
  },
  children: [
    {
      path: "/confirmacao-turmas-mediacao-tecnologica",
      name: "confirmacao-turmas-mediacao-tecnologica",
      meta: {
        allowedPermissions: ["estimativa_matricula_listar"],
        noAuth: true,
      },
      component: () =>
        import(
          "@/views/ConfirmacaoDeTurmasDeMediacaoTecnologica/ConfirmacaoDeTurmasDeMediacaoTecnologicaHome.vue"
        ),
    },
  ],
};

export { confirmacao_turmas_mediacao_tecnologica };
